import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Button, Form, Tooltip, Switch } from "antd";
import { InputCustom } from "../componentes/inputComponent";
import { manejarError } from "../manejo_errores";
import axios from "axios";
import { HeadersAuth } from "../funciones_utiles";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { TablaCompleta } from "../tablas/tabla_simple";
import { FaRegEdit, FaRegTrashAlt,FaDownload  } from "react-icons/fa";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import { PlusOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { Alert} from "antd";
import { resetWarned } from "antd/es/_util/warning";
import { ModalNotificacion } from "../componentes/modalNotificacion";
export const AltaCategoria = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo,mensaje ) => {
      // Usar setAlerta para mostrar la alerta
      setAlerta({ message: mensaje, type: tipo });
    };
  const MySwal = withReactContent(Swal);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    categoria: "",
    reglamento: null,
    nombre_archivo: null,
    anexos: null,
    anexo: null,
    color_fondo: null,
    limiteCubiertas: false,
    limiteInscripciones: false,
    cantidadInscripciones: null,
    cantidadCubiertas: null,
    cargaPrecintos: false,
  }); //Almacena temporalmente los datos del formulario
  const [fetchDatos, setFetchDatos] = useState([]); //Guarda los datos de las categorías obtenidas del backend
  const [refresh, setRefresh] = useState(""); //Se utiliza para forzar la actualización de la lista de categorías
  const [idUnico, setIdUnico] = useState(); //ID del piloto seleccionado para edición
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [mostrarFormularioAnexo, setMostrarFormularioAnexo] = useState(false);
  const [mostrarBotonLimpiar, setMostrarBotonLimpiar] = useState(false);
  const [previewImage, setPreviewImage] = useState(null); // Estado para la vista previa de la imagen
  const fileInputRef = useRef(null); // Referencia para el campo de archivo
  const fileAnexoRef = useRef(null);
  const [abrirModalNotificacion, setAbrirModalNotificacion] = useState(false);
  const [eliminarId, setEliminarId] = useState(null);
  const [dataNotificacion, setDataNotificacion] = useState([]);
  // Función para convertir un archivo a Base64 con encabezado
  const convertirABase64ConEncabezado = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result; // Incluye el encabezado automáticamente
        resolve(base64String); // Resuelve la cadena Base64 completa
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file); // Lee el archivo como Data URL
    });
  };

  // Manejo del cambio en el input de tipo archivo
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        // Verifica que el archivo sea un PDF
        if (!file.type.includes("pdf")) {
          // Muestra una alerta de error
           manejarAlertas("error","El archivo debe ser un PDF válido.")
          
          return;
        }

        // Convierte el archivo a Base64 con encabezado
        const base64ConEncabezado = await convertirABase64ConEncabezado(file);

        // Actualiza el estado con el archivo Base64
        setTempDatosFormulario((prev) => ({
          ...prev,
          reglamento: base64ConEncabezado,
          nombre_archivo: file.name,
        }));
      } catch (error) {
        console.error("Error al convertir el archivo a Base64:", error);
        manejarAlertas("error", "Ocurrió un error al procesar el archivo.");
      }
    }
  };
  const handleFileChangeAnexos = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        // Verifica que el archivo sea un PDF
        if (!file.type.includes("pdf")) {
          // Muestra una alerta de error
           manejarAlertas("error","El archivo debe ser un PDF válido.")
          
          return;
        }

        // Convierte el archivo a Base64 con encabezado
        const base64ConEncabezado = await convertirABase64ConEncabezado(file);

        // Actualiza el estado con el archivo Base64
        setTempDatosFormulario((prev) => ({
          ...prev,
          anexos: base64ConEncabezado,
          anexo: file.name,
        }));
      } catch (error) {
        console.error("Error al convertir el archivo a Base64:", error);
        manejarAlertas("error", "Ocurrió un error al procesar el archivo.");
      }
    }
  };
  const handleImageChange = (e) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      // Validar que el archivo sea una imagen
      if (!file.type.startsWith("image/")) {
        console.warn("El archivo seleccionado no es una imagen válida.");

        manejarAlertas("error", "Solo se permiten archivos de imagen (JPG, JPEG, PNG).");
        return;
      }

      // Convertir el archivo a Base64
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result; // Resultado en Base64

        // Actualiza el estado del formulario con el Base64
        setTempDatosFormulario((prev) => ({
          ...prev,
          color_fondo: base64String, // Guarda la imagen en Base64
        }));

        // Genera una vista previa de la imagen
        setPreviewImage(base64String);
      };
      reader.readAsDataURL(file); // Convierte el archivo a Base64
    } else {
      // console.warn("No se seleccionó ningún archivo válido.");
      manejarAlertas("error", "No se selecciono ningun archivo valido");

    }
  };
  //Carga de datos de la categoría
  // useEffect(() => {
  //   if (idUnico) {
  //     (async () => {
  //       const URI_CATEGORIA = process.env.REACT_APP_DOMINIO + "/categoria/" + idUnico;
  //       console.log("Solicitando datos desde:", URI_CATEGORIA);
  //       const datosCategoria = await traerDatosObjeto(URI_CATEGORIA);
  //       console.log("Datos recibidos:", datosCategoria);
  //     })();
  //   } else {
  //     // Estado inicial cuando no hay ID seleccionado
  //     setTempDatosFormulario({
  //       categoria:"",
  //       año:"",
  //       reglamento: "",
  //     });
  //   }
  // }, [idUnico]);

  const cargarCategoria = async (e) => {
    try {
      let url = idUnico
        ? `${process.env.REACT_APP_DOMINIO}/categoria/${idUnico}` // Actualizar categoría si existe
        : `${process.env.REACT_APP_DOMINIO}/categoria`; // Crear nueva categoría

      let response;

      if (idUnico) {
        // console.log("lo que se envía:", tempDatosFormulario);
        response = await axios.put(url, tempDatosFormulario, HeadersAuth); // Actualización
      } else {
        // console.log("lo que se envía:", tempDatosFormulario);
        response = await axios.post(url, tempDatosFormulario, HeadersAuth); // Creación
      }

      if (response.status === 200) {
        manejarAlertas("success", "Guardado Exitoso");

          setTempDatosFormulario({
            categoria: "",
            año: "",
            reglamento: "",
            anexos: "",
            anexo: "",
            color_fondo: "",
            limiteCubiertas: false,
            limiteInscripciones: false,
            cantidadInscripciones: null,
            cantidadCubiertas: null,
            cargaPrecintos: false,
          });
          // Reinicia el campo de archivo
          if (fileInputRef.current) fileInputRef.current.value = "";
          if (fileAnexoRef.current) fileAnexoRef.current.value = "";

          setIdUnico(null);
          setRefresh(Date.now());
          setMostrarFormulario(false);
					setMostrarBotonLimpiar(false);

          if (response.data.requiereNotificacion) {
            setAbrirModalNotificacion(true)
            setDataNotificacion(response.data.notificacionSistema);
          }
      // console.log("response", response.data)
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));

      
    }
  };

  const renderFilePreview = () => {
    if (idUnico && tempDatosFormulario.nombre_archivo) {
      // Muestra un enlace de descarga para el archivo existente
      return (
        <div style={{ marginTop: "10px", }}>
          <Tooltip title="Descargar Reglamento" placement="top">
            <a
              href={
                process.env.REACT_APP_DOMINIO_ARCHIVOS +
                `/` +
                sesion.id_asociacion +
                `/PDFS/` +
                tempDatosFormulario.nombre_archivo
              }
              target="_blank"
              rel="noopener noreferrer"
              download
              style={{
                width:"auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "2em",
                backgroundColor: "#223463",
                color: "#fff",
                padding: "5px 20px",
                borderRadius: "5px",
                textDecoration: "none",
                fontSize: "16px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
                marginTop: "0.88em",
              }}
            >
              {/* Icono de flecha hacia abajo */}
              <span>↓</span>
     
            </a>
          </Tooltip>
        </div>
      );
    } else if (tempDatosFormulario.reglamento) {
      // Muestra un mensaje indicando que hay un archivo cargado temporalmente
      return (
        <div style={{ marginTop: "10px" }}>
          {/* <Tooltip title="Archivo cargado temporalmente" placement="top">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "2em",
                backgroundColor: "#223463",
                color: "#fff",
                padding: "5px 20px",
                borderRadius: "5px",
                fontSize: "16px",
                cursor: "default",
                transition: "background-color 0.3s ease",
                marginTop: "0.88em",
              }}
            >
             
            </div>
          </Tooltip> */}
        </div>
      );
    }
    return null;
  };
  const renderFilePreviewAnexo = () => {
    if (!idUnico || !tempDatosFormulario.anexo) {
      return null;
    }
  
    // Validar si el nombre del archivo sigue el patrón esperado
    const nombreValido = tempDatosFormulario.anexo.startsWith("anexo_categoria_");
  
    if (!nombreValido) {
      return null; // No mostrar si no es un archivo generado correctamente
    }
  
    const nombreArchivo = encodeURIComponent(tempDatosFormulario.anexo.replace(/\s+/g, '_'));
  
    return (
      <div style={{ marginTop: "10px" }}>
        <Tooltip title="Descargar Anexo" placement="top">
          <a
            href={`${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/pdfs/${nombreArchivo}`}
            target="_blank"
            rel="noopener noreferrer"
            download
            style={{
              width: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "2em",
              backgroundColor: "#223463",
              color: "#fff",
              padding: "5px 20px",
              borderRadius: "5px",
              textDecoration: "none",
              fontSize: "16px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              marginTop: "0.88em",
            }}
          >
            <span>↓</span>
          </a>
        </Tooltip>
      </div>
    );
  };
  
  


  //Obtiene las categorías asociadas a una asociación específica
  useEffect(() => {
    const fetchData = async () => {
      await fetchCategoria(sesion.id_asociacion);
    };

    fetchData();

    // if (fetchDatos.length > 0) {
    //   console.log("Datos de categorías:", fetchDatos);
    // } else {
    //   console.log("No se encontraron categorías");
    // }
  }, [refresh]);

  const fetchCategoria = async (id_asociacion) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/categoria/asociacion/${id_asociacion}`
      );
      if (response.status === 200 && Array.isArray(response.data)) {
        setFetchDatos(response.data); // Asigna los datos a tu estado
        // console.log("cates", response.data)
        // console.log("anexos", response.data[0].anexos)
      } else {
        // console.error();
      manejarAlertas("error", "No se encontró la categoría.");

      }
      setMostrarBotonLimpiar(false);
    } catch (error) {
      manejarAlertas("error", manejarError(error));

      // console.error("Error al obtener categorías:", error);
    }
  };

  const traerDatosObjeto = async (url) => {
    try {
      const response = await axios.get(url, HeadersAuth);
      if (response.status === 200) {
        return response.data;
      } else {
        // console.error("Error al obtener datos:", response.statusText);
        manejarAlertas("error", "Error al obtener datos");
        return null;
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setTempDatosFormulario((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleEdit = async (id) => {
    if (!id) {
      manejarAlertas("error","Erorr al procesar la solicitud.");
      console.error("Error: idUnico es undefined");
      return;
    }
    try {
      const URI_CATEGORIA = process.env.REACT_APP_DOMINIO + "/categoria/" + id;
      const datosCategoria = await traerDatosObjeto(URI_CATEGORIA);
      setTempDatosFormulario(
        {
          categoria: datosCategoria.categoria,
          reglamento: null,
          nombre_archivo: datosCategoria.reglamento,
          anexos: null,
          anexo: datosCategoria.anexo,
          color_fondo: "",
          limiteCubiertas: datosCategoria.limiteCubiertas,
          limiteInscripciones: datosCategoria.limiteInscripciones,
          cantidadInscripciones: datosCategoria.cantidadInscripciones,
          cantidadCubiertas: datosCategoria.cantidadCubiertas,
          cargaPrecintos: datosCategoria.cargaPrecintos,
        } || {}
      );
      // console.log("datosCategoria", datosCategoria)
      if (datosCategoria.color_fondo) {
        setPreviewImage(
          `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/CATEGORIA/${datosCategoria.color_fondo}`
        );
      } else {
        setPreviewImage(``);
      }
      // console.log("pre", previewImage)
      // Mostrar el formulario de gestión de categorías
      setMostrarFormulario(true);
      setMostrarFormularioAnexo(false);
      setMostrarBotonLimpiar(true);
      setIdUnico(id);
    } catch (error) {
      manejarAlertas("error", manejarError(error));

    }
  };

  const handleEditAnexo = async (id_categoria, id_anexo) => {
    if (!id_categoria && !id_anexo) {
      manejarAlertas("error","Erorr al procesar la solicitud.");
      console.error("Error: idUnico es undefined");
      return;
    }
    try {
      const URI_CATEGORIA = process.env.REACT_APP_DOMINIO + "/anexo/" + id_categoria + "/" + id_anexo;
      const datosCategoria = await traerDatosObjeto(URI_CATEGORIA);
      setTempDatosFormulario(
        {
          anexos: null,
          anexo: datosCategoria?.anexo || ""
        }
      );
      // Mostrar el formulario de gestión de categorías
      setMostrarFormularioAnexo(true);
      setMostrarFormulario(false);
      setIdUnico({ id_categoria, id_anexo });

    } catch (error) {
      manejarAlertas("error", manejarError(error));

    }
  };

  const handleActualizarAnexo = async () => {
    if (!idUnico || (!tempDatosFormulario.anexos && !tempDatosFormulario.anexo)) {
      manejarAlertas("error", "Debe subir un anexo o usar el existente.");
      return;
    }
    
  
    const URI = process.env.REACT_APP_DOMINIO + "/anexo/" + idUnico.id_categoria + "/" + idUnico.id_anexo;
  
    try {
      await axios.put(URI, {
        anexoBase64: tempDatosFormulario.anexos,
      }, HeadersAuth);      
      manejarAlertas("success", "Anexo actualizado correctamente.");
      setMostrarFormularioAnexo(false);
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const handleEliminarCategoria = (id) => {
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_DOMINIO}/categoria/pre-eliminar/${id}`,
            HeadersAuth
          );
          // console.log("Pre Eliminación:", response.data);

          // Si requiere notificación → abrir modal ANTES de eliminar
          if (response.data.requiereNotificacion) {
            setAbrirModalNotificacion(true);
            setDataNotificacion(response.data.notificacionSistema); 

            // Guardamos ID para eliminar luego
            setEliminarId(id);
            return;
          }

          // Si NO requiere notificación → eliminar directamente
          await eliminarCategoria(id);
        } catch (error) {
          manejarAlertas("error", manejarError(error));

        }
      }
    });
  };

  useEffect(() => {
    if (!abrirModalNotificacion && eliminarId) {
      eliminarCategoria(eliminarId);
      setEliminarId(null);
    }
  }, [abrirModalNotificacion]);

  const eliminarCategoria= async (id) => {
    try {
      // console.log("id que se envía", id)
      const response = await axios.delete(
        `${process.env.REACT_APP_DOMINIO}/categoria/${id}`,
        HeadersAuth
      );

      manejarAlertas("success", "La categoria ha sido eliminada.");
      setRefresh(Date.now());

    } catch (error) {
      console.error("Error al eliminar la categoria:", error);
      manejarAlertas("error", manejarError(error));
    }
  };

  const handleEliminarAnexo = (id_categoria, id_anexo) => {
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_DOMINIO}/anexo/${id_categoria}/${id_anexo}`,
            HeadersAuth
          );
          if (response.status === 200) {
            // console.log("eliminado", response.data)
            manejarAlertas("success", "La categoria ha sido eliminada.");
            setRefresh(Date.now()); // Actualiza la tabla
          }
        } catch (error) {
          manejarAlertas("error", manejarError(error));

        }
      }
    });
  };

  const limpiarCampos = () => {
    setTempDatosFormulario({
      categoria: "",
      año: "",
      reglamento: "", // Almacena el archivo cargado temporalmente
      anexos: "",
      color_fondo: "",
      limiteCubiertas: false,
      limiteInscripciones: false,
      cantidadInscripciones: null,
      cantidadCubiertas: null,
      cargaPrecintos: false,
    });
    setPreviewImage("");
    setIdUnico(null); // Limpiar el ID del piloto seleccionado
    setMostrarBotonLimpiar(false); // Ocultar el botón "+"
  };
  const mostrarFormularioHandler = () => {
    setMostrarFormulario(true);
    setMostrarBotonLimpiar(false);
    setPreviewImage("");
  };

  const modalAnexos = async (anexos, idCategoria) => {
    try {
      MySwal.fire({
        title: "Cargando...",
        html: '<div style="text-align:center"><i class="fa fa-spinner fa-spin fa-3x"></i></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      // console.log("ID CATEGORÍA:", idCategoria);

      const datosModal = Array.isArray(anexos) ? anexos : [];
      // console.log("anesd", anexos.map((anexo) => ({anexo: anexo.anexo})))
      const anexosHtml = datosModal
      .map(
        (anexo) => `
          <li class="listaContenedora">
            ${anexo.anexo}
            <div class="listacontenedora2">
              <button data-id="${idCategoria}" data-anexo="${anexo.id}" class="btnEditar botonesModal2" style="margin-right:10px;">Editar</button>
              <button data-id="${idCategoria}" data-anexo="${anexo.id}" class="btnEliminar botonesModal2" style="background-color:#BA1721;">Eliminar</button>
              <a 
                href="${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/PDFS/${anexo.anexo}" 
                target="_blank" 
                download 
                class="botonesModal2"
                title="Descargar"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5V13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2.6a.5.5 0 0 1 1 0V13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V10.4a.5.5 0 0 1 .5-.5z"/>
                    <path d="M7.646 10.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 9.293V1.5a.5.5 0 0 0-1 0v7.793L5.354 7.146a.5.5 0 1 0-.708.708l3 3z"/>
                  </svg>
              </a>
            </div>
          </li>`
      )      
      .join("");
      if (datosModal.length > 0) {
        await MySwal.fire({
          title: "Anexos",
          html: `<ul>${anexosHtml}</ul>`,
          showConfirmButton: true,
          confirmButtonText: "Cerrar",
          didOpen: () => {
            document.querySelectorAll(".btnEditar").forEach((btn) => {
              btn.addEventListener("click", () => {
                const idCategoria = btn.dataset.id;
                const idAnexo = btn.dataset.anexo;
                Swal.close();
                handleEditAnexo(idCategoria, idAnexo);
              });
            });
            document.querySelectorAll(".btnEliminar").forEach((btn) => {
              btn.addEventListener("click", () => {
                const idCategoria = btn.dataset.id;
                const idAnexo = btn.dataset.anexo;
                Swal.close();
                handleEliminarAnexo(idCategoria, idAnexo);
              });
            });
            document.querySelectorAll("a[download]").forEach((link) => {
              link.addEventListener("click", () => {
                Swal.close();
              });
            });
          },
        });
      } else {
        await MySwal.fire({
          icon: "info",
          title: "Sin anexos",
          text: "No hay anexos cargados.",
          confirmButtonText: "Cerrar"
        });
      }
      
  
    } catch (error) {
      console.error("Error al cargar los anexos:", error);
      manejarAlertas("error", "No se pudieron cargar los anexos.");
    }
  };
  
  
  const handleSubmit = async () => {
    await handleActualizarAnexo();
  };
  
  
  /*Configuración de la tabla */
  const elScroll = { x: 0 };
  const columns = [
    {
      title: "NOMBRE CATEGORÍA",
      key: "categoria",
      align: "left",
      sorter: (a, b) => a.categoria.localeCompare(b.categoria),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {a.categoria}
        </div>
      ),
    },
    {
      title: "LIMITE CUBIERTAS",
      key: "limiteCubiertas",
      align: "left",
      sorter: (a, b) => a.limiteCubiertas.localeCompare(b.limiteCubiertas),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {a.limiteCubiertas ? "Sí" : "No"}
        </div>
      ),
    },
    {
      title: "CARGA DE PRECINTOS",
      key: "cargaPrecintos",
      align: "left",
      sorter: (a, b) => Number(a.cargaPrecintos) - Number(b.cargaPrecintos),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {a.cargaPrecintos ? "Sí" : "No"}
        </div>
      ),
    },
    {
      title: "LIMITE INSCRIPCIONES",
      key: "limiteInscripciones",
      align: "left",
      sorter: (a, b) => a.limiteInscripciones.localeCompare(b.limiteInscripciones),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {a.limiteInscripciones ? "Sí" : "No"}
        </div>
      ),
    },
    {
      title: "REGLAMENTO",
      key: "reglamento",
      align: "center",
      render: (record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            padding: "2px 4px",
          }}
        >
          {/* Nombre del reglamento */}
          <span style={{ marginRight: "8px" }}>
            {record.reglamento || "No disponible"}
          </span>
      
          {/* Ícono de descarga */}
          {record.reglamento ? (
            <Tooltip title="Descargar Reglamento" placement="top">
              <a
                href={`${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${
                sesion.id_asociacion
              }/PDFS/${record.reglamento}`}
                target="_blank"
                rel="noopener noreferrer"
                download
                style={{
                  color: "#223463",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                <FaDownload />
              </a>
            </Tooltip>
          ) : null}
        </div>
      ),
    },
    {
      title: "ANEXOS",
      key: "anexos",
      align: "center",
      render: (record) => {
        // console.log("rec", record)
        const archivosAnexos = record.anexos;
        return (
          <Button 
            onClick={() => modalAnexos(archivosAnexos, record.id)}
            style={{ fontSize: "12px", padding: "4px 8px", backgroundColor: "rgb(186, 23, 33)", color: "#fff" }}
          >
            Ver anexos
          </Button>

        );
      },
    },
    
    
    {
      title: () => (
        <div style={{ textAlign: "center" }}>
          <span></span>
        </div>
      ),
      key: "opciones",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FaRegEdit
            className="iconos-tablas"
            style={{ color: "blue", cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(record.id)}
          />
          <FaRegTrashAlt
            className="iconos-tablas"
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => handleEliminarCategoria(record.id)}
          />
        </div>
      ),
    },
  ];
  const esTelefono = useMediaQuery({ maxWidth: 768 });
  return (
    <>
    
      {/* Título-Carga Categorías*/}
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Gestión de categorías</h1>
      </section>

      {/* inputFecha-selectFecha-botónUp-botónCargar*/}
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* Contenedor principal para ambos formularios */}
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            padding: "20px",
            margin: "0 auto",
          }}
        >
          {mostrarFormulario && (
            <Form layout="vertical" onFinish={cargarCategoria}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "1em",
                }}
              >
                <h1 className="titulos-secundarios">Datos de la categoría</h1>
                {/* Botón Limpiar */}
                {mostrarBotonLimpiar && (
                  <BotonPrincipal
                    texto="Nueva categoría"
                    onClick={limpiarCampos}
                  />
                )}
                {" "}
              </div>
              <hr></hr>
              <Row gutter={16} 
                className="rowMostrarForm" >
                <Col xs={24} sm={8}>
                  <Form.Item
                  style={{ width: "100%",
                    //maxWidth: "300px"
                   }}>
                    <InputCustom
                      idCampo="categoria"
                      nombreCampo="Nombre de Categoría"
                      tipo="text"
                      elValue={tempDatosFormulario.categoria || ""}
                      elPlaceholder="Nombre de Categoría"
                      required
                      onChange={handleChange}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}
                  className="colMostrarForm"
                  style={{ 
                    display: "flex",
                    flexDirection: "row",
                    gap: 20,
                    width: "100%",
                  }}>
                    <Form.Item
                      style={{
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%"
                        }}
                      >
                        {/* Botón personalizado */}
                        <label
                          htmlFor="file-upload-reglamento"
                          title={tempDatosFormulario.nombre_archivo || "Subir reglamento"}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            height: 30,
                            backgroundColor: "#223463",
                            color: "#fff",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            border: "none",
                            outline: "none",
                            transition: "background-color 0.3s ease",
                            marginTop: "1.5em",
                            overflow: "hidden", // 👈 importante para ocultar texto extra
                          }}
                        >
                          {/* Icono de flecha hacia arriba */}
                          <span style={{ marginRight: "10px" }}>↑</span>

                          {/* Línea vertical */}
                          <span
                            style={{
                              height: "30px",
                              width: "0.5px",
                              backgroundColor: "#fff",
                              margin: "0 10px",
                            }}
                          ></span>

                          {/* Texto dinámico con corte */}
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden", 
                              textOverflow: "ellipsis", 
                              maxWidth: "70%", 
                              textAlign: "center",
                            }}
                          >
                            {tempDatosFormulario.nombre_archivo || "Subir reglamento"}
                          </span>
                        </label>

                        {/* Input de archivo oculto */}
                        <input
                          id="file-upload-reglamento"
                          type="file"
                          accept=".pdf"
                          onChange={handleFileChange}
                          ref={fileInputRef}
                          style={{ display: "none" }}
                        />
                      </div>
                      {/* {renderFilePreview()} */}
                    </Form.Item>
                </Col>
                <Col xs={24} sm={8} 
                  style={{ 
                    display: "flex",
                    flexDirection: "row",
                    gap: 20,
                    width: "100%",
                  }}
                >
                  <Form.Item
                    style={{
                      width: "100%"
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      {/* Botón personalizado */}
                      <label
                      className="labelForm"
                        htmlFor="file-upload-anexo"
                        style={{
                          display: "flex",
                          height: "auto",
                          width:"100%",
                          height: 30,
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#223463",
                          color: "#fff",
                          padding: "5px 10px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          fontSize: "16px",
                          border: "none",
                          outline: "none",
                          transition: "background-color 0.3s ease",
                          marginTop: "1.5em",
                          overflow: "hidden",
                        }}
                      >
                        {/* Icono de flecha hacia arriba */}
                        <span style={{ marginRight: "10px" }}>↑</span>
                        {/* Línea vertical */}
                        <span
                          style={{
                            height: "30px",
                            width: "0.5px",
                            backgroundColor: "#fff",
                            margin: "0 10px",
                          }}
                        ></span>
                        {/* Texto dinámico con corte */}
                        <span
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden", 
                            textOverflow: "ellipsis", 
                            maxWidth: "70%", 
                            textAlign: "center",
                          }}
                        >
                          {tempDatosFormulario.anexo ||
                          "Subir anexo"}
                        </span>
                      </label>
                      {/* Input de archivo oculto */}
                      <input
                        id="file-upload-anexo"
                        type="file"
                        accept=".pdf"
                        onChange={handleFileChangeAnexos}
                        ref={fileAnexoRef}
                        style={{ display: "none" }}
                      />
                    </div>
                    {/* {renderFilePreviewAnexo()} */}
                  </Form.Item>
                </Col>
                </Row>
                <Row
                  gutter={16} 
                  className="rowMostrarForm"
                >
                  <Col
                    xs={24} sm={6}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 20,
                      width: "100%",
                    }}
                    >
                    <Form.Item
                      style={{
                        width: "100%"
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%",
                        }}
                      >
                        <p
                          className="nombre-campo"
                          style={{marginTop: "0.1em"}}
                        >
                          Color de categoría(opcional)
                        </p>
                        {/* Botón personalizado */}
                        <label
                        className="labelForm"
                          htmlFor="file-upload-color_fondo"
                          style={{
                            display: "flex",
                            height: "auto",
                            width:"100%",
                            height: 26,
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#BA1721",
                            color: "#fff",
                            padding: "4px 8px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "13px",
                            border: "none",
                            outline: "none",
                            transition: "background-color 0.3s ease",
                            // marginRight: "1em",
                          }}
                        >
                          <span style={{ marginRight: "8px" }}>↑</span>
                            <span
                              style={{
                                height: "26px",
                                width: "0.5px",
                                backgroundColor: "#fff",
                                margin: "0 8px",
                              }}
                            ></span>
                            Subir imagen
                          </label>
                          <input
                            id="file-upload-color_fondo"
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={handleImageChange}
                            style={{ display: "none", width: "100%" }}
                          />
                        </div>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={3}>
                    <Form.Item style={{ width: "100%" }}>
                      <p className="nombre-campo" style={{ marginBottom: "0.5em" }}>
                        Carga de precintos
                      </p>

                      <Switch
                        checked={tempDatosFormulario.cargaPrecintos || false}
                        onChange={(checked) =>
                          setTempDatosFormulario((prev) => ({
                            ...prev,
                            cargaPrecintos: checked,
                          }))
                        }
                        style={{
                          backgroundColor: tempDatosFormulario.cargaPrecintos
                          ? "#223463"
                          : "#BA1721",
                        }}
                        checkedChildren="Sí"
                        unCheckedChildren="No"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={3}>
                    <Form.Item style={{ width: "100%" }}>
                      <p className="nombre-campo" style={{ marginBottom: "0.5em" }}>
                        Límite de cubiertas
                      </p>

                      <Switch
                        checked={tempDatosFormulario.limiteCubiertas || false}
                        onChange={(checked) =>
                          setTempDatosFormulario((prev) => ({
                            ...prev,
                            limiteCubiertas: checked,
                          }))
                        }
                        style={{
                          backgroundColor: tempDatosFormulario.limiteCubiertas
                          ? "#223463"
                          : "#BA1721",
                        }}
                        checkedChildren="Sí"
                        unCheckedChildren="No"
                      />
                    </Form.Item>
                  </Col>
                  {tempDatosFormulario.limiteCubiertas && (
                    <Col xs={24} sm={4}>
                      <Form.Item style={{ width: "100%" }}>
                        <InputCustom
                          idCampo="cantidadCubiertas"
                          nombreCampo="Cantidad cubiertas"
                          tipo="number"
                          elValue={tempDatosFormulario.cantidadCubiertas || ""}
                          elPlaceholder="Ingrese el límite"
                          required
                          onChange={handleChange}
                        />
                      </Form.Item>
                    </Col>
                  )}
                  <Col xs={24} sm={4}>
                    <Form.Item style={{ width: "100%" }}>
                      <p className="nombre-campo" style={{ marginBottom: "0.5em" }}>
                        Límite de inscripciones
                      </p>

                      <Switch
                        checked={tempDatosFormulario.limiteInscripciones || false}
                        onChange={(checked) =>
                          setTempDatosFormulario((prev) => ({
                            ...prev,
                            limiteInscripciones: checked,
                            cantidadInscripciones: checked ? prev.cantidadInscripciones : null,
                          }))
                        }
                        style={{
                          backgroundColor: tempDatosFormulario.limiteInscripciones
                            ? "#223463"
                            : "#BA1721",
                        }}
                        checkedChildren="Sí"
                        unCheckedChildren="No"
                      />
                    </Form.Item>
                  </Col>

                {tempDatosFormulario.limiteInscripciones && (
                  <Col xs={24} sm={4}>
                    <Form.Item style={{ width: "100%" }}>
                      <InputCustom
                        idCampo="cantidadInscripciones"
                        nombreCampo="Cantidad inscripciones"
                        tipo="number"
                        elValue={tempDatosFormulario.cantidadInscripciones || ""}
                        elPlaceholder="Ingrese el límite"
                        required
                        onChange={handleChange}
                      />
                    </Form.Item>
                  </Col>
                )}
                </Row>
                <Row 
                  gutter={16} 
                  align="middle"
                  className="rowBotonForm"
                >
                  <Col xs={24} sm={18}
                    className="botonesResponsive"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                    }}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="boton-principal"
                      >
                        {idUnico ? "Actualizar" : "Guardar"}
                      </Button>
                  </Col>
                  <Col xs={24} sm={6}>
                      {/* Contenedor para la vista previa de la imagen */}
                      <div 
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        {previewImage && (
                          <img
                            src={previewImage}
                            alt="Vista previa"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "8px", // Añade bordes redondeados para un diseño más moderno
                              border: "1px solid #ddd", // Agrega un borde sutil para destacar la imagen
                            }}
                          />
                        )}
                      </div>
                  </Col>
              </Row>
            </Form>
          )}
          {mostrarFormularioAnexo && (
            <Form layout="vertical" onFinish={handleSubmit}>
              <h1 className="titulos-secundarios">Datos de la categoría</h1>
              <hr></hr>
              <Row gutter={16} >
                <Col xs={24} sm={8}>
                  <p style={{ 
                    fontSize: "1.2em",
                    fontWeight: "normal",
                    color: "var(--grisIntermedio)",
                    alignSelf: "start",
                    marginTop: "0.2em"
                   }}
                  >
                    Actualizar anexo:
                  </p>
                  <Form.Item
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      {/* Botón personalizado */}
                      <label
                        htmlFor="file-upload-anexo"
                        style={{
                          display: "flex",
                          height: "auto",
                          width:"100%",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#223463",
                          color: "#fff",
                          padding: "5px 10px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          fontSize: "16px",
                          border: "none",
                          outline: "none",
                          transition: "background-color 0.3s ease",
                          marginTop: "0.5em",
                          // marginRight: "1em",
                        }}
                      >
                        {/* Icono de flecha hacia arriba */}
                        <span style={{ marginRight: "10px" }}>↑</span>
                        {/* Línea vertical */}
                        <span
                          style={{
                            height: "30px",
                            width: "0.5px",
                            backgroundColor: "#fff",
                            margin: "0 10px",
                          }}
                        ></span>
                        {/* Texto dinámico */}
                        {tempDatosFormulario.anexo ||
                          "Subir Anexo"}
                      </label>
                      {/* Input de archivo oculto */}
                      <input
                        id="file-upload-anexo"
                        type="file"
                        accept=".pdf"
                        onChange={handleFileChangeAnexos}
                        ref={fileAnexoRef}
                        style={{ display: "none" }}
                      />
                    </div>
                    {renderFilePreviewAnexo()}
                  </Form.Item>
                </Col>
                </Row>
                <Row gutter={16} align="middle">
                <Col xs={24} sm={8}
                className="botonesResponsive"
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="boton-principal"
                  >
                    {idUnico?.id_anexo ? "Actualizar" : "Guardar"}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>
      </section>

      {/* Lista de Reglamento*/}
      <div
        className="botonDescargar"
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "flex-end",
           padding:"0 16px"
        }}
      >
        <br></br>
          <TablaCompleta
            elScroll={elScroll}
            mostrarBoton={false}
            columns={columns}
            fetchDatos={fetchDatos.length > 0 ? fetchDatos : []}
            rowKey={"id"}
            gestionTabla={
              <Row style={{ gap: "10px" }}>
                {!mostrarFormulario && (
                  <BotonPrincipal
                  texto={esTelefono ? <PlusOutlined /> : "Agregar"}
                    onClick={mostrarFormularioHandler}
                  />
                )}
              </Row>
            }
            mostrarBotonDescargar={false}
          />
        </div>
      {dataNotificacion.length > 0 && (
        <ModalNotificacion
          open={abrirModalNotificacion}
          onCancel={() => setAbrirModalNotificacion(false)}
          datos={dataNotificacion}
          id_asociacion={sesion.id_asociacion}
          HeadersAuth={HeadersAuth}
          setAlerta={setAlerta}
        />
      )}
    </>
  );
};
